import React from 'react';

import './index.scss';

const SystemNotice: React.FC = () => {
  return (
    <div className="system-notice-page">
      <div className="system-notice-page__inner">
        <div className="system-notice-page__title">系统升级改造中</div>
        <div className="system-notice-page__content">
          因系统升级调整，当前页面暂时停止访问，相关功能暂停使用。升级完成时间将另行通知，由此给您带来的不便，敬请谅解。如有疑问，请联系
          <a href="mailto:ad_isv@tencent.com"> ad_isv@tencent.com</a>
        </div>
        <div className="system-notice-page__sign">
          <div>腾讯营销</div>
          <div>2026年04月30日</div>
        </div>
      </div>
    </div>
  );
};

export default SystemNotice;
